export const EXTERNAL_FACE_TO_FACE_CONFIG: object = {
  id: "CL001.38",
  name: "com.integrum.configurationService.utils.templateGenerator.model.SectionTemplate",
  cards: [
    {
      id: "CL010.315",
      his: false,
      type: "formCard",
      hisV2: true,
      access: "write",
      inputs: {
        comment: {
          type: "fixedLabelTextAreaInput",
          label: "Comment",
          sortOrder: 4,
          componentId: "comment",
          carryThrough: true,
        },
        createdBy: {
          type: "fixedLabelSearchSelect",
          label: "createdBy",
          sortOrder: 3,
          componentId: "createdBy",
          carryThrough: true,
          readonly: true,
          shouldSetToActiveUser: true,
          shouldFilterByCredentials: false,
        },
        conductedBy: {
          type: "fixedLabelSearchSelect",
          label: "conductedBy",
          sortOrder: 1,
          componentId: "conductedBy",
          placeholder: "Search by name...",
          carryThrough: true,
          shouldFilterByCredentials: true,
          shouldSearchCredentialedResourceProviders: true,
          rules: {
            required: true,
          },
        },
        importantInformation: {
          type: "displayStaticText",
          label: "externalFaceToFaceVisitImportantInformation",
          sortOrder: 2,
          componentId: "importantInformation",
          carryThrough: true,
        },
      },
      layout: [
        {
          rows: [
            {
              cols: [
                {
                  rows: [
                    {
                      id: "conductedBy",
                    },
                  ],
                },
                {
                  rows: [
                    {
                      id: "importantInformation",
                    },
                  ],
                },
              ],
              type: "row",
            },
            {
              cols: [
                {
                  rows: [
                    {
                      id: "createdBy",
                    },
                  ],
                },
                {
                  rows: [
                    {
                      id: "comment",
                    },
                  ],
                },
              ],
              type: "row",
            },
          ],
        },
      ],
      cardName: "faceToFaceExternal",
      sortOrder: 1,
      dependencies: [],
    },
  ],
  resourceKey: "/faceToFaceExternal",
  sectionName: "faceToFaceExternal",
  authorizedToDisplay: true,
  editAfterCompleteAssessment: false,
};



// WEBPACK FOOTER //
// ./src/mocks/sections/mock-external-face-to-face.ts